import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import { reducer as oidcReducer } from "redux-oidc";
import userReducer from "./users/getUsers";
import createUserReducer from "./users/createUser";
import allCategories from "../reducers/Categories/allCategories";
import allLocations from "../reducers/Locations/allLocations";
//import notification from '../reducers/Notifications';
import notifyReducer from 'react-redux-notify';
import { reducer as formReducer } from 'redux-form'
import { create } from "domain";
import customFieldsReducer from '../reducers/CustomFields/customFields'
import allClients from "../reducers/Clients/allClients";
import clientReducer from "./Clients/getClients";

const createRootReducer = (history) => combineReducers({
    oidc: oidcReducer,
    router: connectRouter(history),
    userReducer,
    createUserReducer,
    allCategories,
    allLocations,
    allClients,
    //notification,
    notifications: notifyReducer,
    form: formReducer,
    customFieldsReducer,
    clientReducer
});

export default createRootReducer;
